import React, { useContext } from "react";
import { JointBillContext } from "@features/JointBillList/utils";
import { Skeleton } from "@components/Skeleton/Skeleton";

export const HeaderNameCellSkeleton: React.FC = () => {
  const { isSummaryMode } = useContext(JointBillContext);

  return (
    <div className="flex items-center gap-4">
      <Skeleton
        variant="circular"
        className="hidden h-[52px] w-[52px] md:block"
      />
      <div className="flex flex-col gap-1">
        <Skeleton className="text-md w-64" />
        {!isSummaryMode && (
          <div className="flex gap-2">
            <div className="flex gap-2">
              <Skeleton className="w-20 text-sm" />
              <Skeleton className="w-36 text-sm" />
            </div>
          </div>
        )}
        <div className="md:hidden">
          <Skeleton variant="rounded" className="h-5 w-32" />
        </div>
      </div>
    </div>
  );
};
